import { ThemeProvider as MuiThemeProvider } from '@mui/material'
import { FC } from 'react'
import { theme } from './theme'

const ThemeProvider: FC = ({ children }) => <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>

export { ThemeProvider }
